import { useRef } from 'react';


import React from 'react';
import { MetaTags } from 'react-meta-tags';
import { Container, Row, Col } from 'reactstrap';
import { DashBreadcrumb } from '../../components/Common/Breadcrumb';
import WishlistList from './components/WishlistList';
import { DateRangePicker } from 'rsuite';

const WishlistIndex = () => {
    const wishlistListRef = useRef();
    // Export date range state for DateRangePicker
    const [dateRangeValue, setDateRangeValue] = React.useState(null); // [startDate, endDate]
    const [exportRange, setExportRange] = React.useState({ from: '', to: '' });
    const disableFutureDates = date => date > new Date();
    const handleDateChange = range => {
        setDateRangeValue(range);
        if (range && range.length === 2) {
            setExportRange({
                from: range[0] ? range[0].toISOString().slice(0, 10) : '',
                to: range[1] ? range[1].toISOString().slice(0, 10) : ''
            });
        } else {
            setExportRange({ from: '', to: '' });
        }
    };
    const handleDateClose = () => {
        setDateRangeValue(null);
        setExportRange({ from: '', to: '' });
    };
    const [exportLoading, setExportLoading] = React.useState(false);
    const triggerExport = async () => {
        if (wishlistListRef.current && wishlistListRef.current.handleExport) {
            setExportLoading(true);
            try {
                await wishlistListRef.current.handleExport(exportRange);
            } finally {
                setExportLoading(false);
            }
        }
    };
    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Wishlist View</title>
                </MetaTags>
                <Container fluid>
                    <Row className="align-items-center mb-2">
                        <Col xl={6} className="d-flex align-items-center">
                            <DashBreadcrumb
                                title="Wishlist"
                                breadcrumbItem="Wishlist View"
                            />
                        </Col>
                        <Col xl={2}></Col>
                        <Col xl={4} className="d-flex justify-content-end align-items-center" style={{ gap: 8 }}>
                            <label className="mb-0 me-1">Date Range:</label>
                            <div className="daterange-container flex-grow-1">
                                <DateRangePicker
                                    size="md"
                                    style={{ width: '100%' }}
                                    placement="auto"
                                    placeholder="Select a Date Range"
                                    showOneCalendar={false}
                                    disabledDate={disableFutureDates}
                                    onChange={handleDateChange}
                                    onClean={handleDateClose}
                                    value={dateRangeValue}
                                />
                            </div>
                            <button className="btn btn-dark ms-2" onClick={triggerExport} disabled={exportLoading}>
                                {exportLoading ? (
                                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                ) : null}
                                Export as Excel
                            </button>
                        </Col>
                    </Row>
                    <WishlistList ref={wishlistListRef} />
                </Container>
            </div>
        </React.Fragment>
    );
};

export default WishlistIndex;
